import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import moment from 'moment';
import React from 'react';
import { lpad } from '../../../utils/helper';

const Columns = (onDelete: (leagueId: string) => Promise<void>, onEdit, onDetailClick) => {
    return [
        {
            title: 'ID',
            dataIndex: 'id',
            render: (value) => lpad(value, 5).toUpperCase(),
        },
        {
            title: 'League Name',
            dataIndex: 'name',
        },
        {
            title: 'Coin Required',
            dataIndex: 'coin',
        },
        {
            title: 'League Start',
            dataIndex: 'start',
            render: (value) => moment(value).format('MM/DD/YYYY HH:mm'),
        },
        {
            title: 'League End',
            dataIndex: 'end',
            render: (value) => moment(value).format('MM/DD/YYYY HH:mm'),
        },
        {
            title: 'Created',
            dataIndex: 'createdAt',
            render: (value) => moment(value).format('MM/DD/YYYY'),
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            align: 'left',
            render: (id, record) => (
                <div className={'action-button'}>
                    <div>
                        <EyeOutlined onClick={() => onDetailClick?.(record)} />
                    </div>
                    <div>
                        <EditOutlined onClick={() => onEdit?.(id)} />
                    </div>
                    <div style={{ display: 'none' }}>
                        <Popconfirm
                            title="Sure to delete?"
                            okText={'Yes'}
                            cancelText={'No'}
                            onConfirm={async () => await onDelete(id)}
                        >
                            <DeleteOutlined />
                        </Popconfirm>
                    </div>
                </div>
            ),
            width: '10%',
        },
    ];
};
export { Columns };
